import { jsx } from "react/jsx-runtime";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { validateTidalLicense } from "../../base/index.js";
function AttachFile(props) {
  return /* @__PURE__ */ jsx(
    AttachFileIcon,
    {
      "data-testid": "AttachFile",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AttachFile",
      "data-tidal-icon-meta": "editing,attachment"
    }
  );
}
AttachFile.tidalIconMeta = {
  categories: "editing,attachment",
  name: "AttachFile"
};
validateTidalLicense();
export {
  AttachFile
};
//# sourceMappingURL=AttachFile.js.map
